import { SET_VALUE_ROUTING } from '../../../actions/afyaImara/routing';
import { routingRules } from './routing';

import {
    AFYA_IMARA_QUOTE_FORM_SET_VALUE,
    AFYA_IMARA_QUOTE_FORM_SET_VALID,
    SET_SHARE_EMAIL_VALUE,
    SET_SHARE_EMAIL_VALID,
} from '../../../actions/afyaImara/quote';
import { quoteFormRules } from './quote';
import { shareQuoteFormRules } from './shareQuote';

import {
    AFYA_IMARA_PERSONAL_DETAILS_FORM_SET_VALUE,
    AFYA_IMARA_PERSONAL_DETAILS_FORM_SET_VALID,
} from '../../../actions/afyaImara/personalDetails';
import { personalDetailsFormRules } from './personalDetails';

import {
    AFYA_IMARA_CHILD_DETAILS_FORM_SET_VALUE,
    AFYA_IMARA_CHILD_DETAILS_FORM_SET_VALID,
} from '../../../actions/afyaImara/childDetails';
import { childDetailsFormRules } from './childDetails';

import {
    AFYA_IMARA_SPOUSE_DETAILS_FORM_SET_VALUE,
    AFYA_IMARA_SPOUSE_DETAILS_FORM_SET_VALID,
} from '../../../actions/afyaImara/spouseDetails';
import { spouseDetailsFormRules } from './spouseDetails';

import {
    AFYA_IMARA_NEXT_OF_KIN_FORM_SET_VALID,
    AFYA_IMARA_NEXT_OF_KIN_FORM_SET_VALUE,
} from '../../../actions/afyaImara/nextOfKin';
import { nextOfKinFormRules } from './nextOfKin';

// medical history
import {
    AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE,
    AFYA_IMARA_MEDICAL_HISTORY_SET_VALID,
} from '../../../actions/afyaImara/medicalHistory';
import { medicalHistoryFormRules } from './medicalHistory';
import {
    AFYA_IMARA_DOCUMENTS_FORM_SET_VALID,
    AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE,
} from '../../../actions/afyaImara/Documents';
import { documentsFormRules } from './documents';

import { PAYMENTS_SET_VALID, PAYMENTS_SET_VALUE } from '../../../actions/afyaImara/payments';
import { paymentsFormRules } from './payments';

import {
    AFYA_IMARA_AGENT_MODAL_DETAILS_SET_VALUE,
    AFYA_IMARA_AGENT_MODAL_DETAILS_SET_VALID,
} from '../../../actions/afyaImara/agentModal';
import { agentModalFormRules } from './agentModal';

export const afyaImaraRules = (store, next, action) => {
    if (action.type.startsWith(AFYA_IMARA_MEDICAL_HISTORY_SET_VALUE) || action.type.startsWith(AFYA_IMARA_MEDICAL_HISTORY_SET_VALID)) {
        return medicalHistoryFormRules(store, next, action);
    }
    if (action.type.startsWith(SET_VALUE_ROUTING)) {
        return routingRules(store, next, action);
    }
    if (
        action.type.startsWith(AFYA_IMARA_QUOTE_FORM_SET_VALUE) ||
        action.type.startsWith(AFYA_IMARA_QUOTE_FORM_SET_VALID)
    ) {
        return quoteFormRules(store, next, action);
    }

    if (
        action.type.startsWith(AFYA_IMARA_PERSONAL_DETAILS_FORM_SET_VALUE) ||
        action.type.startsWith(AFYA_IMARA_PERSONAL_DETAILS_FORM_SET_VALID)
    ) {
        return personalDetailsFormRules(store, next, action);
    }

    if (
        action.type.startsWith(AFYA_IMARA_CHILD_DETAILS_FORM_SET_VALUE) ||
        action.type.startsWith(AFYA_IMARA_CHILD_DETAILS_FORM_SET_VALID)
    ) {
        return childDetailsFormRules(store, next, action);
    }

    if (
        action.type.startsWith(AFYA_IMARA_SPOUSE_DETAILS_FORM_SET_VALUE) ||
        action.type.startsWith(AFYA_IMARA_SPOUSE_DETAILS_FORM_SET_VALID)
    ) {
        return spouseDetailsFormRules(store, next, action);
    }

    if (
        action.type.startsWith(AFYA_IMARA_NEXT_OF_KIN_FORM_SET_VALUE) ||
        action.type.startsWith(AFYA_IMARA_NEXT_OF_KIN_FORM_SET_VALID)
    ) {
        return nextOfKinFormRules(store, next, action);
    }

    if (
        action.type.startsWith(AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE) ||
        action.type.startsWith(AFYA_IMARA_DOCUMENTS_FORM_SET_VALID)
    ) {
        return documentsFormRules(store, next, action);
    }

    if (action.type.startsWith(PAYMENTS_SET_VALUE) || action.type.startsWith(PAYMENTS_SET_VALID)) {
        return paymentsFormRules(store, next, action);
    }

    if (
        action.type.startsWith(AFYA_IMARA_AGENT_MODAL_DETAILS_SET_VALUE) ||
        action.type.startsWith(AFYA_IMARA_AGENT_MODAL_DETAILS_SET_VALID)
    ) {
        return agentModalFormRules(store, next, action);
    }

    if (action.type.startsWith(SET_SHARE_EMAIL_VALUE) || action.type.startsWith(SET_SHARE_EMAIL_VALID)) {
        return shareQuoteFormRules(store, next, action);
    }

    return null;
};
